export default __webpack_public_path__ + "static/media/Months_17.fbc67f69.png";